import type { TypeDate } from '@/types/api'

function normalizeTypeDateField(value: number | string | undefined | null): number | undefined {
  if (value === undefined || value === null) {
    return undefined
  }
  if (typeof value === 'number') {
    return value
  }
  if (typeof value === 'string') {
    if (value.length === 2 && value.startsWith('0')) {
      return parseInt(value.slice(1), 10)
    }
    return parseInt(value, 10)
  }
  return value
}

export function normalizeTypeDate(date: TypeDate | null | undefined): TypeDate | null | undefined {
  if (date == null) {
    return date
  }
  return {
    year: normalizeTypeDateField(date.year) ?? date.year,
    month: normalizeTypeDateField(date.month) ?? date.month,
    day: normalizeTypeDateField(date.day) ?? date.day
  }
}
